import reporter from "./reporter";

/**
 * 登录埋点
 * https://doc.huanleguang.com/pages/viewpage.action?pageId=79889193
 * @param {{
 *  userId: string|number,
 *  login_type:string,
 *  is_cache_login: boolean,
 *  client_name?: string
 * }} data 页面信息  page_name sub_page_nm
 */
export default function loginTracker(data) {
  try {
    const trackData = {
      event_id: 39001,
      event_name: "login",
      is_verify_code_login: false,
      login_type: "auto_login",
      ...data,
    };

    reporter(trackData);
  } catch (error) {
    console.error(error);
  }
}
